// extracted by mini-css-extract-plugin
export default {"confirmModal":"styles_confirmModal__ah1eo","text":"styles_text__snEE-","emoji":"styles_emoji__DX1WK","buttonsWrapper":"styles_buttonsWrapper__0W3fG"};